





























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import router from '@/router';
import axios from 'axios';

@Component
export default class CardOverviewPeople extends CompanyMixin {
  getInterval(code: string) {
    switch (code) {
      case 'INTERVALL5': return 'Kontrollerar 100 %';
      case 'INTERVALL4': return 'Kontrollerar 75-99 %';
      case 'INTERVALL3': return 'Kontrollerar 50-75 %';
      case 'INTERVALL2': return 'Kontrollerar 25-50 %';
      case 'INTERVALL1': return 'Kontrollerar maximalt 25 %';
    }
    return '';
  }

  getFunction(func: string) {
    switch (func) {
      case 'Ledamot': return 'Ledamot';
      case 'Suppleant': return 'Suppleant';
      case 'Vice Verkställande Direktör': return 'Vice VD';
      case 'Extern Firmatecknare': return 'Extern Firmatecknare';
    }
    return '';
  }

  get board() {
    if (!this.overview) {
      return [];
    }
    return this.overview.DIRECTORS
        .filter((x: any) => ['Ledamot', 'Suppleant'].indexOf(x.Function) !== -1);
  }

  get management() {
    if (!this.overview) {
      return [];
    }
    return this.overview.DIRECTORS
        .filter((x: any) => ['Vice Verkställande Direktör', 'Extern Firmatecknare'].indexOf(x.Function) !== -1);
  }

  download(template: string, fileName: string) {
    user.setFetchingData(true);
    user.setFetchingMessage('Genererar PDF...');

    axios({
      method: 'get',
      url: this.targetUri(template),
      responseType: 'arraybuffer',
    })
      .then((response) => {
        user.setFetchingData(false);
        this.forceFileDownload(response, fileName);
      })
      .catch(() => {
        user.setFetchingData(false);
        console.log('an error occurred');
      });
  }

  targetUri(template: string) {
    const u = user.user;
    if (!u || !this.overview) {
      return;
    }
    return `/api/pdf/quick/kyc/${u.UserId}/${u.Version}/${this.overview.OrgNr}/0`;
  }

  forceFileDownload(response: any, fileName: string) {
    const data = new Blob([response.data], { type: 'application/pdf' });

    // IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(data, fileName);
      return;
    }

    const url = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(url);
    }, 100);
  }

  get pending() {
    return user.fetchingData && user.fetchingMessage !== 'Genererar PDF...';
  }
}
